import React, { useState, useEffect } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import TabInlay from './components/TabInlay'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { SIDEPANEL_WIDTH } from '../../utils'
import { openSidePanelPopOver, updateUi } from '../../dux/ui/actions'
import { useCloseSidePanelPopOver } from './hooks'

export default function SidePanel(props) {
  const [ activeKey, setActiveKey ] = useState('staff')
  const { groups, staff, residents, current_user, organization, config } = useSelector(state=>state)
  const dispatch = useDispatch()
  const handleCloseSidePanelPopOver = useCloseSidePanelPopOver()

  useEffect(()=>{ if (window.location.hash) setActiveKey(window.location.hash.substr(1)) },[])

  useEffect(()=>{
    // todo (REFACTOR) consolidate all event listeners related to staff app in a single javascript file and import then everywhere they are used
    if (config.isStaffApp) {
      var staffAppMetaData = document.getElementById('staffAppMetaData')
      document.addEventListener('openAgendaFilter', (e) =>  {
        dispatch(openSidePanelPopOver())
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "STAFF_APP_META_DATA", payload: {
          rbbLabel: null,
          rbbUri: null,
          lbbUri: 'dispatch://closeAgendaFilter'
        }}))
      });

      document.addEventListener('closeAgendaFilter', (e) =>  {
        handleCloseSidePanelPopOver()
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "STAFF_APP_META_DATA", payload: staffAppMetaData.dataset }))
      });

    }
  },[])


  return (
    <Variant {...props}>
      <Tabs
        mountOnEnter
        activeKey={activeKey}
        className="border-top d-flex justify-content-around"
        onSelect={(key) => setActiveKey(key)}>
        <Tab title="Staff" eventKey="staff">
          <TabInlay items={staff} kind="user"/>
        </Tab>
        <Tab title="Clients" eventKey="clients">
          <TabInlay items={residents} kind="resident"/>
        </Tab>
        <Tab title="Groups" eventKey="groups">
          <TabInlay items={groups} kind="calendar">
            <a 
              href={`/organizations/${organization.name}/new_calendar`}
              className="btn btn-sm btn-primary text-white d-block mt-4">
              Create New Group
            </a>
          </TabInlay>
        </Tab>
      </Tabs>
    </Variant>
  )
}

function Variant({ children, variant }){
  const { visible } = useSelector(state=>state.ui.sidePanelPopOver)
  const { config } = useSelector(state=>state)
  const handleCloseSidePanelPopOver = useCloseSidePanelPopOver()

  return variant == 'popover' ?
  <PopOver id="side_panel" style={{ padding: 0, display: visible ? "block" : "none"}}>
    {
      !config.isStaffApp &&
      <div className="d-flex justify-content-end border-bottom">
        <span onClick={handleCloseSidePanelPopOver} className="btn btn-primary">
          <span>Back to Agenda</span>
        </span>
      </div>
    }
    {children}
  </PopOver> : 
  <div id="side_panel" className="h-100 border d-none d-lg-block" transition='false' style={{width: SIDEPANEL_WIDTH }}>{children}</div>
}

const PopOver = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 55px;
  background-color: white;
  display: inline-block;
  z-index: 1000;
`